import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/Home.vue'
import About from './views/About.vue'
import Rank from './views/Rank.vue'
import Editor from './views/Editor.vue'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'home',
      component: Home
    },
    {
      path: '/about',
      name: 'about',
      component: About
    },
    {
      path: '/rank',
      name: 'rank',
      component: Rank
    },
    {
      path: '/rank/:id',
      name: 'rank',
      component: Rank
    },
    {
      path: '/editor',
      name: 'editor',
      component: Editor
    }
  ]
})
